module.exports = __webpack_public_path__ + "img/title1@2x.f8b19c94.png";